import { render } from "./BookingCalendar.vue?vue&type=template&id=b1ae11de&scoped=true"
import script from "./BookingCalendar.vue?vue&type=script&lang=js"
export * from "./BookingCalendar.vue?vue&type=script&lang=js"

import "./BookingCalendar.vue?vue&type=style&index=0&id=b1ae11de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ae11de"]])

export default __exports__